import translations from './const/uz_cyrl.json';

export default {
  translation: {
    ...translations
  }
}